module.exports = __webpack_public_path__ + "images/icon-image-placeholder-50c8f841bfea19d7e5965dd61a6f6f24.svg";